import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { createSession } from './net/session';
import { SessionProvider } from './session/SessionProvider';
import './theme/tokens.css';

const session = createSession();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SessionProvider session={session}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SessionProvider>
  </StrictMode>,
);
